<template>
    <div class="uploadPicture-model" v-if="isShow">
        <div class="model-bg" @click="cancel"></div>
        <div class="uploadPicture-modelCon">
            <div class="review-search-nav bg-blue">
                <div class="review-search-cancel div--inlineBlock js-navCancel" @click="cancel">取消</div>
                <div class="review-search-clear div--inlineBlock js-navClear" @click="clear">清空筛选</div>
                <div class="review-search-confirm div--inlineBlock js-navSubmit" @click="ok">确认</div>
            </div>
            <div class="uploadPicture-modelContainer">
                <div class="uploadPicture-modelChoice">
                    <div class="uploadPicture-choiceItem" v-for="(item, index) in selectedList" :key="index"><span>{{item.text}}</span><div class="js-modelCloseBtn" @click="deleteItem(index)">X</div></div>
                </div>
                <div class="uploadPicture-choiceMenu">
                    <ul class="uploadPicture-choiceMenuL scroll-container">
                        <li v-bind:class="{active: showType === 0}" @click="selectType(0)">
                            <span class="">图片类型</span>
                            <ul class="uploadPicture-choiceMenuR" v-if="showType === 0">
                                <li v-for="item in tagsList" :key="item.id" @click="selectTag(item)" v-bind:class="{active: checkActive(0, item)}"><span>{{item.title}}</span><span class="uploadPicture-choiceCheck" aria-hidden="true"></span></li>
                            </ul>
                        </li>

                        <li v-bind:class="{active: showType === 1}" @click="selectType(1)">
                            <span class="">游轮名称</span>
                            <ul class="uploadPicture-choiceMenuR" v-if="showType === 1">
                                <li v-for="(item, index) in shipList" :key="index" @click="selectShip(item)" v-bind:class="{active: checkActive(1, item)}"><span>{{item.shipCNName}}</span><span class="uploadPicture-choiceCheck" aria-hidden="true"></span></li>
                            </ul>
                        </li>

                        <li v-bind:class="{active: showType === 2}" @click="selectType(2)">
                            <span class="">出航日期</span>
                            <ul class="uploadPicture-choiceMenuR" v-if="showType === 2">
                                <li v-for="(item, index) in dateList" :key="index" @click="selectDate(item)" v-bind:class="{active: checkActive(2, item)}"><span>{{item.sailDate}}</span><span class="uploadPicture-choiceCheck" aria-hidden="true"></span></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'UploadFilter',
        props: {
            isShow: {
                type: Boolean,
                default: false
            },
            filterData: {
                type: Object,
                default: function () {}
            },
            initData: {
                type: Array,
                default: function () {}
            },
            shipCode: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                showType: 0, // 0 图片类型 1 邮轮名称 2 出航日期
                selectedList: [],
                tagsList: [],
                shipList: [],
                cruises: [],
                dateList: [],
                thisShipCode: ''
            }
        },
        watch: {
            'filterData' (newVal) {
                this.init(newVal)
            },
            'initData' (newVal) {
                this.selectedList = newVal
            },
            'shipCode' (newVal) {
                this.thisShipCode = newVal
            },
            'thisShipCode' (newVal) {
                if (newVal) {
                    this.dateList = this.filterDate(newVal)
                    // 添加 更早的日期
                    this.dateList = [...this.dateList, {sailDate: '更早的日期'}]
                } else {
                    this.dateList = [{sailDate: '更早的日期'}]
                }
            }
        },
        methods: {
            init (data) {
                this.tagsList = data.tags
                this.shipList = data.ships
                this.cruises = data.cruises
            },
            cancel () {
                this.$emit('on-cancel')
            },
            clear () {
                this.selectedList = []
                this.thisShipCode = ''
                this.$emit('on-clear')
            },
            ok () {
                this.$emit('on-confirm', {
                    list: this.selectedList,
                    shipCode: this.thisShipCode
                })
            },
            selectType (type) {
                this.showType = type
            },
            selectTag (item) {
                let arr = this.selectedList.filter(ele => ele.type === 0)
                let result = this.selectedList.find(ele => ele.text === item.title)
                let index = this.selectedList.indexOf(result)
                if (result) {
                    this.selectedList.splice(index, 1)
                    return
                }
                if (arr.length >= 3) {
                    this.$alert.show('标签最多选3个')
                } else {
                    this.selectedList.push({
                        type: 0,
                        text: item.title
                    })
                }
            },
            selectShip (item) {
                let result = this.selectedList.find(ele => ele.type === 1)
                let index = this.selectedList.indexOf(result)
                if (result) {
                    this.selectedList.splice(index, 1)
                    this.thisShipCode = ''
                }
                if (!result || item.shipCNName !== result.text) {
                    this.selectedList.push({
                        type: 1,
                        text: item.shipCNName
                    })
                    this.thisShipCode = item.shipCode
                }
            },
            selectDate (item) {
                let result = this.selectedList.find(ele => ele.type === 2)
                let index = this.selectedList.indexOf(result)
                if (result) this.selectedList.splice(index, 1)
                if (!result || item.sailDate !== result.text) {
                    this.selectedList.push({
                        type: 2,
                        text: item.sailDate
                    })
                }
            },
            filterDate (shipCode) {
                return this.cruises.filter(item => item.shipCode === shipCode)
            },
            checkActive (type, item) {
                if (this.selectedList.length === 0) return false
                let result = false,
                    arr = this.selectedList.filter(ele => ele.type === type)
                if (type === 0) {
                    result = arr.some(ele => {
                        if (ele.text === item.title) return true
                    })
                }
                if (type === 1) {
                    result = arr.some(ele => {
                        if (ele.text === item.shipCNName) return true
                    })
                }
                if (type === 2) {
                    result = arr.some(ele => {
                        if (ele.text === item.sailDate) return true
                    })
                }
                return result
            },
            deleteItem (index) {
                if (this.selectedList[index].type === 1) {
                    this.thisShipCode = ''
                }
                this.selectedList.splice(index, 1)
            }
        }
    }
</script>

<style lang="less">
    /**** model(类型、船期) ****/
    .uploadPicture-model {
        position: absolute;
        top: 0;
        left:0;
        z-index:2;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.5);
        padding-top:50px;
        .model-bg{
            display: block;
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
        .uploadPicture-modelCon {
            position: relative;
            z-index: 2;
            background:#fff;
            .review-search-nav {
                color: white;
                font-size: 13px;
                height: 36px;
                line-height: 36px;
                padding: 0px 20px;
                position: relative;
            }
            .review-search-confirm {
                position: absolute;
                top: 0px;
                right: 20px;
            }
            .review-search-cancel {
                position: absolute;
                top: 0px;
                left: 20px;
            }
            .review-search-clear {
                border-radius: 5px;
                height: 28px;
                line-height: 28px;
                padding: 0px 5px;
                border: 1px solid white;
                position: absolute;
                top: 3px;
                left: 153px;
            }
        }
        .uploadPicture-modelContainer {
            .uploadPicture-modelChoice {
                overflow: hidden;
                margin-left: 11px;
                .uploadPicture-choiceItem{
                    float:left;
                    margin-right:9px;
                    margin-top: 8px;
                    color:#666;
                    font-size:12px;
                    position: relative;
                    padding: 2px 28px 2px 10px;
                    background-color: #efefef;
                    border-radius:6px;
                    &>span{
                        color:#666;
                        font-size:12px;
                    }
                    &>div {
                        position:absolute;
                        top:2px;
                        right:6px;
                        transform:scaleX(1.4);
                        -webkit-transform:scaleX(1.4);
                        padding:0 4px;
                    }
                }
            }
        }
        .uploadPicture-choiceMenu {
            position: relative;
            height: 175px;
            margin-top:10px;
            ul{
                list-style:none;
                padding:0;
                margin:0;
                li{
                    width:100%;
                    text-align:center;
                    height:35px;
                    line-height:35px;
                    color:#666;
                    font-size:13px;
                    border-bottom:1px solid #e0e0e0;
                }
            }
            .uploadPicture-choiceMenuL {
                width:107px;
                height:175px;
                background-color:#f0f0f0;
                overflow-y:auto;
                &>li.active {
                    background-color:#061556;
                    color:#fff;
                }
            }
            .uploadPicture-choiceMenuR {
                width:260px;
                border-top:1px solid #e0e0e0;
                height:175px;
                overflow-y:auto;
                position:absolute;
                top:0;
                right:0;
                -webkit-overflow-scrolling: auto;
                &>li {
                    margin-right:7px;
                    position:relative;
                    &.active{
                        color:#061556;
                        .uploadPicture-choiceCheck{
                            display:inline-block;
                        }
                    }
                    .uploadPicture-choiceCheck{
                        position:absolute;
                        right:20px;
                        top:9px;
                        width:6px;
                        height:12px;
                        border:solid #f0af11;
                        border-width:0 2px 2px 0;
                        transform:rotate(45deg);
                        -webkit-transform:rotate(45deg);
                        display:none;
                    }
                }
            }
        }
    }
</style>
